/**
 * WordPress dependencies
 */
import { applyFilters } from '@wordpress/hooks';

/**
 * External dependencies
 */
import FontIconPicker from '@fonticonpicker/react-fonticonpicker';
import { fontAwesome } from '@fonticonpicker/react-fonticonpicker/src/docs/helpers/iconDefs';

const IconPicker = ( { onChange, value } ) => {
	console.log( fontAwesome );
	return <FontIconPicker
		{ ...{
			icons: applyFilters( 'gutenify--icon-picker--fonts-list', fontAwesome ),
			// theme: 'bluegrey',
			renderUsing: 'class',
			value,
			onChange: ( val ) => {
				onChange( val );
			},
		} }
	/>;
};

export default IconPicker;
